import HelpTriggerIcon from './HelpTriggerIcon';
export * from './HelpTriggerIcon';
export default HelpTriggerIcon;
